// aboutData.js
import loginImage from "../../../assets/login.PNG";
import addEvents from "../../../assets/addEvents.PNG";
import view from "../../../assets/viewSchedule.PNG";

const data = [
  {
    id: 1,
    title: "Login",
    text: "Access your account securely.",
    className: "card_middle",
    image: loginImage,
  },
  {
    id: 2,
    title: "Add Event",
    text: "Effortlessly schedule and manage events.",
    className: "card_left",
    image: addEvents,
  },
  {
    id: 3,
    title: "View Schedule",
    text: "Stay organized and plan your activities.",
    className: "card_right",
    image: view,
  },
];

export default data;
